export const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

// The complaint "issuedBy.type" values that count as a real, user-facing
// complaint. "internal" and "procedure" are machine-generated and must be
// excluded from every complaint list/count the exec app shows.
export const COMPLAINT_SOURCE_TYPES = ["customerSupport", "public", "independentEngineer"];
